import { Grid } from "@mui/material";
import { getAssets, shortenLargeNumber } from "@unisearch/helpers";
import styles from "./countdown_two.module.scss";

export const CountdownTwo = ({ isPaddingBig }) => {
  return (
    <section
      className={`${styles.section_countdown} ${
        isPaddingBig ? styles.paddingbig : ""
      }`}
    >
      <div className="container">
        <div className={styles.wrapper}>
          <Grid
            container
            spacing={2}
            alignItems={"center"}
            className={styles.countdown_left}
          >
            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.count_wrapper}>
                <img
                  className={styles.oval}
                  src={getAssets("assets/images/home/oval.webp")}
                  alt="Oval"
                />
                <img
                  className={styles.square}
                  src={getAssets("assets/images/home/square.webp")}
                  alt="Square"
                />

                <ul className={styles.count_lists}>
                  <li className={styles.count_list}>
                    <span className={styles.count_number}>
                      {shortenLargeNumber(1000000)}+
                    </span>
                    <span className={styles.count_text}>
                      Active
                      <br /> Prospects
                    </span>
                  </li>

                  <li className={styles.count_list}>
                    <span className={styles.count_number}>
                      {shortenLargeNumber(6)}+
                    </span>
                    <span className={styles.count_text}>
                      Study Abroad <br /> Countries
                    </span>
                  </li>

                  <li className={styles.count_list}>
                    <span className={styles.count_number}>
                      {shortenLargeNumber(600)}+
                    </span>
                    <span className={styles.count_text}>
                      Colleges, Universities <br /> & Institutes
                    </span>
                  </li>

                  <li className={styles.count_list}>
                    <span className={styles.count_number}>
                      {shortenLargeNumber(8000)}+
                    </span>
                    <span className={styles.count_text}>
                      Programs <br />
                      of Study
                    </span>
                  </li>
                </ul>
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              className={styles.countdown_right}
            >
              <div className={`${styles.title_wrapper}`}>
                <h2 className={`${styles.title} fw400`}>
                  UniSearch is Your <br />
                  <span className="mark">Complete Access</span> <br />
                  Point
                </h2>
                <p className={`${styles.sub_title}`}>
                  — where international student experience and intelligent
                  technology converge to make study abroad solutions simpler
                  than ever.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default CountdownTwo;
